import React, { FC } from 'react';

import { Text } from '@nerdwallet/currency/components/Text';
import { Box } from '@nerdwallet/currency/components/Box';
import { Stack } from '@nerdwallet/currency/components/Stack';
import { Tooltip } from '@nerdwallet/currency/components/Tooltip';

import { FormInput } from './form-builder/form-input';
import styles from './styles.module.scss';

const AutoInfoForm: FC = () => {
  return (
    <Stack spacing="3">
      <Box display="flex" alignItems="center">
        <Text bold>Vehicle information</Text>

        <Box marginLeft="1">
          <Tooltip
            content={
              <div className={styles.tooltip}>
                <Text size="small">
                  This information was shared by your insurer when you linked
                  your auto insurance policy to your NerdWallet account. You can
                  update it at any time to affect your rate report.
                </Text>
              </div>
            }
          />
        </Box>
      </Box>

      <FormInput field="zipCode" label="Parking ZIP code" fullWidth />

      <div className={styles.twoColumnGrid}>
        <FormInput field="carYear" fullWidth label="Car year" />
        <FormInput field="carMake" fullWidth label="Car make" />
      </div>

      <FormInput field="carModel" fullWidth label="Car model" />
    </Stack>
  );
};

export default AutoInfoForm;
